import React, { Component } from "react";
import ChatBot from "react-simple-chatbot";
import { withRouter } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { connect } from "react-redux";
import {
  chatContainerStyle,
  chatContainerStyleMobile,
  chatContentStyle,
  chatbotContentStyleMobile,
  chatbotAvatarStyle,
  chatbotAvatarStyleMobile,
  chatbotBubbleStyle,
  chatbotFooterStyle,
  chatbotBubbleStyleMobile,
  helloAvaTheme
} from "../../utils/styles";

import { ChatContainer } from "../onboarding/OnboardingStyles";
import * as util from "../../utils/util";

import "../onboarding/Onboarding.css";

class Stor_Onboarding extends Component {
  constructor(props) {
    super(props);

    this.handleEnd = this.handleEnd.bind(this);

    this.state = {
      viewport: {
        width: document.documentElement.clientWidth,
        height: window.innerHeight
      }
    };
  }

  componentDidMount() {
    window.addEventListener("resize", this.handleMediaQueries.bind(this));
    let prevent = false;

    // document
    //   .querySelector(".rsc-container")
    //   .addEventListener("touchstart", function(e) {
    //     console.log(e.touches.length)
    //     if (e.touches.length !== 1) {
    //       return;
    //     }

    //     let scrollY =
    //       window.pageYOffset ||
    //       document.body.scrollTop ||
    //       document.documentElement.scrollTop;
    //     prevent = scrollY === 0;
    //   });

    // document
    //   .querySelector(".rsc-container")
    //   .addEventListener("touchmove", function(e) {
    //     if (prevent) {
    //       prevent = false;
    //       e.preventDefault();
    //     }
    //   });
      
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleMediaQueries.bind(this));
  }

  handleMediaQueries() {
    this.setState({
      viewport: {
        width: document.documentElement.clientWidth,
        height: window.innerHeight
      }
    });
  }

  handleEnd({ steps }) {
    let requestBody = {};
    // The request must contain the 15 survey answers
    if (steps["A5"]) {
      requestBody = {
        "A6": steps["A6"].value,

        "A8-1": steps["A7-1"].value,
        "A8-2": steps["A7-2"].value,
        "A8-3": steps["A7-3"].value,
        "A8-4": steps["A7-4"].value,
        "A8-5": steps["A7-5"].value,
        "A8-6": steps["A7-6"].value,
        "A8-7": steps["A7-7"].value,
        "A8-8": steps["A7-8"].value,
        "A8-9": steps["A7-9"].value,
        "A8-10": steps["A7-10"].value,
        "A8-11": steps["A7-11"].value,
        "A8-12": steps["A7-12"].value
      };
    }

    // The request may have a user id if user signin
    if (localStorage.getItem("user_id")) {
      requestBody["userId"] = localStorage.getItem("user_id");
    }

  

    // The request may have user profile info if user has not signin
    if (steps["A3"] && !localStorage.getItem("user_has_hair_profile")) {
      requestBody["firstName"] = steps["A1-1"].value.split(":")[0];
      requestBody["lastName"] = steps["A1-1"].value.split(":")[1];
      requestBody["age"] = steps["A2"].value;
      requestBody["gender"] = steps["A2-A"].value;


      if (!localStorage.getItem("user_id")) {
        requestBody["email"] = steps["A10"].value.split(":")[0];
        requestBody["phoneNumber"] = steps["A10"].value.split(":")[1];
        requestBody["password"] = steps["A10"].value.split(":")[2];
        requestBody["region"] = steps["A10"].value.split(":")[4];   // 电话的区号
      }
    }

    try {
      requestBody["budget"] = steps["A5"].value;
    } catch (error) {}
    

    if (util.isMobile(navigator.userAgent)) {
      requestBody["signupSource"] = "mobile";
    }


    // Redirect to home if user says 'No' to region question.https://helloavadev.atlassian.net/browse/HD-357
    if (steps["Q2-1"]) {
      setTimeout(() => {
        this.props.history.push("/");
      }, 2000);
      return;
    }

    try {
      if (steps["A1"] && steps["A1"].value == 'no') {
        setTimeout(() => {
          if(this.props.history.length > 0){
            this.props.history.goBack();
          }else{
            this.props.history.push("/");
          }
        }, 2000);
        return;
      }
    } catch (error) {
      console.log("once more onboarding ")
    }



    if (Object.keys(requestBody).length > 0) {
      var utm_source = sessionStorage.getItem("utm_source");
      // 合作结束功能关闭了
      // if(utm_source){
      //   requestBody["enrollFrom"] = utm_source
      //   requestBody["hasPaid"] = true
      // }

      // 线下popup活动
      requestBody["enrollFrom"] = 'popup';
      

      fetch("/api/surveys/advanced", {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(requestBody)
      })
        .then(response => {
          // if (localStorage.getItem('auth_token')) {
          //     localStorage.setItem("user_has_skin_profile", true);
          //     window.location.href = '/survey-result';
          //     // return;
          // } else {
          return response.json();
          // }
        })
        .then(json => {
          // If this is a new user, we need to save the token and user id
          if (json.token) {


            try {
              const firstName = requestBody["firstName"];
              const lastName = requestBody["lastName"];
              localStorage.setItem("user_firstname", firstName);
              localStorage.setItem("user_global_firstname", firstName);
              localStorage.setItem("user_lastname", lastName);
              localStorage.setItem("user_global_lastname", lastName);
            } catch (error) {
              localStorage.setItem("user_firstname", '');
              localStorage.setItem("user_global_firstname", '');
              localStorage.setItem("user_lastname", '');
              localStorage.setItem("user_global_lastname", '');
            }


            const phoneNumber = requestBody["phoneNumber"];
            const email = requestBody["email"];
            const budget = requestBody["budget"];
          

            localStorage.setItem("phone_number", phoneNumber);
            localStorage.setItem("user_global_phone", phoneNumber);
            localStorage.setItem("email", email);
            localStorage.setItem("user_global_email", email);
            localStorage.setItem("budget", budget);



            localStorage.setItem("auth_token", json.token.token);
            localStorage.setItem("auth_expires", parseInt(json.token.expires / 1000));
            localStorage.setItem("user_id", json.userId);

           

            localStorage.removeItem("gateFeePaid");
            localStorage.setItem("temp_new_user_flag", true);
            localStorage.setItem("recohasnotseenreco", true);
            localStorage.setItem('user_global_enrollFrom','popup');


            // this.addNewUserToMailList(firstName, lastName, phoneNumber, email);

            if(utm_source){
              this.fun_userShowRecommendation().then(() => {
                sessionStorage.removeItem("utm_source");
                 this.props.history.push({ pathname: "/recommendations" });
              })
            }else{
              this.props.history.push({ pathname: "/recommendations" });
            }
            localStorage.setItem("user_has_skin_profile", true);

          }else{
            if(json.description){
              // alert(json.description)
            }else{
              this.props.history.push({ pathname: "/recommendations" });
            }
          }

        })
        .catch(error => {
          alert(
            error
            // "There was a problem saving your survey answers. Please try again. "
          );
          console.log(error);
        });
    }
  }
  //指定网站过来的用户不需要交十美元咨询费
  fun_userShowRecommendation(){
    return fetch("/api/user-flags", {
      method: 'PATCH',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'x-auth-token': localStorage.getItem("auth_token")
      },
      body: JSON.stringify({
          userId: localStorage.getItem("user_id"),
          showRecommendation: true
      })
    }).then(response => {
        return;
    }).catch(function(err) {
      console.log(err);
    });
  }

  // 此方法不使用了，放后台了
  addNewUserToMailList(firstName, lastName, phoneNumber, email) {
    // fetch("https://api.airtable.com/v0/app1i1EUDcShUEpYn/Table%201", {
    //   method: "POST",
    //   headers: {
    //     Authorization: "Bearer " + process.env.REACT_APP_AIRTABLE_API_KEY,
    //     Accept: "application/json",
    //     "Content-Type": "application/json"
    //   },
    //   body: JSON.stringify({
    //     fields: {
    //       "First Name": firstName,
    //       "Last Name": lastName,
    //       Phone: phoneNumber,
    //       Email: email
    //     }
    //   })
    // });
  }

  render() {
    const chatbotStyle = {
      // width: "100%",
      // maxWidth: "unset",
      // height: "100%",
      // background: "#fff"
    };

    const chatbotStyleMobile = {
      width: "100%",
      maxWidth: "996px",
      //maxHeight: '100%',
      height: "100%",
      //height: (window.innerHeight * 0.925 - window.innerHeight * 2 * 0.032 - 20) + 'px', // 20 is the header logo height
      //height: this.state.viewport.height - 20,
      background: "#fff",
      overflow: "hidden",
      overflowY: "scroll"
    };
    let touchsupport =
      "ontouchstart" in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0;

    return (
      <ChatContainer>
        <ThemeProvider theme={helloAvaTheme}>
          <ChatBot
            className={!touchsupport ? "nontouch" : ""}
            hideHeader={true}
            hideUserAvatar={true}
            // botAvatar="/images/onboarding/ava-chat.svg"
            botAvatar="https://res.cloudinary.com/dhybuxeqg/image/upload/w_500,c_fill,ar_1:1,g_auto,r_max/v1615540194/hello/images/recommendations/image_iblmlm.png"
            steps={this.props.steps}
            handleEnd={this.handleEnd}
            style={chatbotStyle}
            contentStyle={chatContentStyle}
            // floatingStyle={chatContainerStyle}
            avatarStyle={
              this.state.viewport.width >= 900
                ? chatbotAvatarStyle
                : chatbotAvatarStyleMobile
            }
            bubbleStyle={
              this.state.viewport.width >= 900
                ? chatbotBubbleStyle
                : chatbotBubbleStyleMobile
            }
            footerStyle={chatbotFooterStyle}
            // customDelay={2000}
            // botDelay={2000}
          />
        </ThemeProvider>
      </ChatContainer>
    );
  }
}

export default withRouter(connect()(Stor_Onboarding));



// WEBPACK FOOTER //
// ./src/views/storeonboarding/Stor_Onboarding.js